<template>
	<material-popup :dialogShowModel="showEditTenant" @escintent="showEditTenant = false">
		<ValidationObserver ref="observer" v-slot="{ failed }">
			<material-card icon="fas fa-laptop-house" :title="$t('tenant.edit_title')" dismissable @dismissed="showEditTenant = false">
				<v-form autocomplete="off">
					<v-row dense class="justify-center">
						<v-col cols="12" xs="12" sm="10">
							<ValidationProvider ref="fullname" vid="fullname" :name="$t('tenant.fullname')" rules="required" v-slot="{ errors, field }">
								<v-text-field class="required" :label="$t('tenant.fullname')" v-model="temporaryTenant.fullname" :error-messages="errors" :autofocus="$appOptions.canAutofocus()"></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="12" xs="12" sm="2">
							<ValidationProvider vid="ateco" :name="$t('tenant.ateco')" rules="" v-slot="{ errors, field }">
								<v-text-field :label="$t('tenant.ateco')" v-model="temporaryTenant.ateco" :error-messages="errors"></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="12" xs="12" sm="6">
							<ValidationProvider ref="shortname" vid="shortname" :name="$t('tenant.shortname')" rules="required|max:30" v-slot="{ errors, field }">
								<v-text-field class="required" :label="$t('tenant.shortname')" v-model="temporaryTenant.shortname" :error-messages="errors"></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="12" xs="12" sm="3">
							<ValidationProvider vid="taxcode" :name="$t('tenant.taxcode')" rules="min:11|max:16" v-slot="{ errors, field }">
								<v-text-field :label="$t('tenant.taxcode')" v-model="temporaryTenant.taxcode" :error-messages="errors"></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="12" xs="12" sm="3">
							<ValidationProvider vid="vatid" :name="$t('tenant.vatid')" rules="min:11|max:16" v-slot="{ errors, field }">
								<v-text-field :label="$t('tenant.vatid')" v-model="temporaryTenant.vatid" :error-messages="errors"></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="12" xs="12" sm="4">
							<ValidationProvider vid="email" :name="$t('tenant.email')" rules="email|required" v-slot="{ errors, field }">
								<v-text-field type="email" class="required" :label="$t('tenant.email')" v-model="temporaryTenant.email" :error-messages="errors"></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="12" xs="12" sm="4">
							<ValidationProvider vid="phone" :name="$t('tenant.phone')" rules="" v-slot="{ errors, field }">
								<v-text-field type="tel" :label="$t('tenant.phone')" v-model="temporaryTenant.phone" :error-messages="errors"></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="12" xs="12" sm="4">
							<ValidationProvider vid="whatsapp" :name="$t('tenant.whatsapp')" rules="" v-slot="{ errors, field }">
								<v-text-field type="tel" :label="$t('tenant.whatsapp')" v-model="temporaryTenant.whatsapp" :error-messages="errors"></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="12" xs="12" sm="5">
							<ValidationProvider vid="address" :name="$t('tenant.address')" rules="" v-slot="{ errors, field }">
								<v-text-field :label="$t('tenant.address')" v-model="temporaryTenant.address" :error-messages="errors"></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="12" xs="12" sm="4">
							<ValidationProvider vid="city" :name="$t('tenant.city')" rules="" v-slot="{ errors, field }">
								<v-text-field :label="$t('tenant.city')" v-model="temporaryTenant.city" :error-messages="errors"></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="6" xs="6" sm="2">
							<ValidationProvider vid="state" :name="$t('tenant.state')" rules="" v-slot="{ errors, field }">
								<v-text-field :label="$t('tenant.state')" v-model="temporaryTenant.state" :error-messages="errors"></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="6" xs="6" sm="1">
							<ValidationProvider vid="postcode" :name="$t('tenant.postcode')" rules="" v-slot="{ errors, field }">
								<v-text-field type="number" :label="$t('tenant.postcode')" v-model="temporaryTenant.postcode" :error-messages="errors"></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="12" xs="12" sm="4">
							<ValidationProvider vid="website" :name="$t('tenant.website')" rules="" v-slot="{ errors, field }">
								<v-text-field :label="$t('tenant.website')" v-model="temporaryTenant.website" :error-messages="errors"></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="6" xs="6" sm="3">
							<ValidationProvider vid="redditivity" :name="$t('tenant.redditivity')" rules="required" v-slot="{ errors, field }">
								<v-text-field type="number" :label="$t('tenant.redditivity')" v-model="temporaryTenant.redditivity" :error-messages="errors" suffix="%" v-mask="'##'"></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="6" xs="6" sm="2">
							<ValidationProvider vid="vat_year" :name="$t('tenant.vat_year')" rules="" v-slot="{ errors, field }">
								<v-text-field type="number" :label="$t('tenant.vat_year')" v-model="temporaryTenant.vat_year" :error-messages="errors"></v-text-field>
							</ValidationProvider>
						</v-col>
						<v-col cols="12" xs="12" sm="3">
							<v-checkbox hide-details :label="$t('tenant.force_aliquota_15')" v-model="temporaryTenant.force_aliquota_15">
								<info-box slot="prepend" :title="$t('tenant.force_aliquota_15')" :message="$t('tenant.force_aliquota_15_description')"></info-box>
							</v-checkbox>
						</v-col>
					</v-row>
				</v-form>
				<template slot="actions">
					<v-col cols="6" xs="6" sm="3">
						<action-button large @click="showEditTenant = false" outlined :text="$t('global.undo')"></action-button>
					</v-col>
					<v-col cols="6" xs="6" sm="3">
						<action-button large @click="editTenant()" color="success" :text="$t('global.save')"></action-button>
					</v-col>
				</template>
			</material-card>
		</ValidationObserver>
	</material-popup>
</template>

<script>
export default {
	data: () => ({}),
	computed: {
		apierrors() {
			return this.$store.getters.getApiErrors;
		},
		temporaryTenant: {
			get: function () {
				return this.$store.getters.getTemporaryTenant;
			},
			set: function (value) {
				this.$store.commit("setTemporaryTenant", value);
			},
		},
		showEditTenant: {
			get: function () {
				return this.$store.getters.showEditTenant;
			},
			set: function (value) {
				if (value == false) {
					this.$store.dispatch("hideAction", "hideEditTenant");
				}
			},
		},
	},
	methods: {
		editTenant() {
			this.$refs.observer.validate().then((isValid) => {
				if (isValid == true) {
					this.$store.dispatch("updateTenant");
				}
			});
		},
	},
	watch: {
		apierrors: {
			handler: function (val) {
				this.$functions.ApiErrorsWatcher(val, this.$refs.observer);
			},
			deep: true,
		},
	},
};
</script>
